module.exports = __webpack_public_path__ + "static/img/subscribe1.d7404a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mastheads/subscribe1.jpg
// module id = 7+jW
// module chunks = 1